export default "__VITE_ASSET__20436729__"